




















import { BaseStatuses } from '@/constants/status-constants';
import { DashboardGaugeMixin } from '@/dashboards/dashboard-gauge-mixin';
import { StatusesStore } from '@/families/store/statuses-store';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { LocaleMixin } from '@/locales/locale-mixin';
import { getModule } from 'vuex-module-decorators';
import { DashboardStore } from '@/store/dashboard-store';
import { AppStateStore } from '@/store/app-state-store';
import Highcharts from 'highcharts';
import {
    getGaugeChartOptions,
    getGaugeStopColors,
    getSolidGaugeSeriesOptions
} from '@/charts/chart-utils';
import { LoadingStore } from '@/store/loading-store';
import { getGoodLeadsPct } from '@/dashboards/corp-dashboard-stats';
import { getPreviousDateFilter } from '@/date-time/date-filter-utils';
import GaugeComparison from '@/dashboards/components/GaugeComparison.vue';
import cloneDeep from 'lodash/cloneDeep';

const appState = getModule(AppStateStore);
const dashboardState = getModule(DashboardStore);
const loadingState = getModule(LoadingStore);
const statusesState = getModule(StatusesStore);

@Component({
    components: { GaugeComparison }
})
export default class GoodLeadsGaugeGraph extends Mixins(DashboardGaugeMixin, LocaleMixin) {
    @Prop({ type: String }) readonly graphId!: undefined;

    private includeLostOpp = false;
    private isMounted = false;
    private loadingKey = 'goodLeads';
    private diffPct = 0;
    private stops = [0.0, 0.08, 0.37, 0.79];

    chartOptions: Highcharts.Options = Highcharts.merge(cloneDeep(getGaugeChartOptions()), {
        spacingRight: 0,
        spacingLeft: 0,
        yAxis: {
            stops: getGaugeStopColors(this.stops)
        },
        exporting: {
            chartOptions: {
                title: {
                    text: 'New Families Getting To Wait List or Registered'
                }
            }
        }
    });

    get org() {
        return appState.storedCurrentOrg;
    }

    get dateRange() {
        return dashboardState.storedDateFilter;
    }

    async created() {
        await statusesState.init();
        this.includeLostOpp = statusesState.storedStatuses.find(status => status.id === BaseStatuses.LOST_OPP) !== undefined;
        await this.updateChart();
    }

    mounted() {
        this.isMounted = true;
    }

    @Watch('org', { deep: true })
    async orgChanged() {
        await this.updateChart();
    }

    @Watch('dateRange', { deep: true })
    async dateRangeChanged() {
        await this.updateChart();
    }

    private async updateChart() {
        if (!this.org) {
            return;
        }
        if (!this.dateRange.startDate || !this.dateRange.endDate) {
            return;
        }
        loadingState.loadingIncrement(this.loadingKey);
        loadingState.loadingIncrement(this.loadingKey);
        const org = this.org.id;
        let mainPct = 0;
        let prevPct = 0;
        getGoodLeadsPct(this.dateRange, org, this.includeLostOpp).then((value) => {
            mainPct = value;
            this.chartOptions.series = [getSolidGaugeSeriesOptions('Conversion rate from New Family to Wait List or Registered', mainPct)];
            this.diffPct = mainPct - prevPct;
            loadingState.loadingDecrement(this.loadingKey);
            this.$emit('updated', mainPct);
            (this.$refs.chart as any).chart.reflow();
        });
        getGoodLeadsPct(getPreviousDateFilter(this.dateRange), org, this.includeLostOpp).then((value) => {
            prevPct = value;
            this.diffPct = mainPct - prevPct;
            loadingState.loadingDecrement(this.loadingKey);
            (this.$refs.chart as any).chart.reflow();
        });
    }
}
